/**
 * @description 3个子配置，通用配置
 */
const setting = require('./setting.config')
module.exports = Object.assign({}, setting)
